import { Note, NoteActivityType } from "@/models/Note";

export interface Consultation {
    id: number | null;
    patientId: number | string | undefined;
    storeId: number;
    storeName: string;
    status: number;
    statusName: string;
    clinical: boolean;
    requested: string;
    patientName: string;
    dateOfBirth: string;
    phoneNumber: string;
    created: Date;
    createdBy: string;
    closed: Date | null;
    closedBy: string;
    rxNumber?: number | null;
    type: ConsultationType;
    category: ConsultationCategory;
    completionQuestionSetId?: number;

    // The following are just a part of the view model
    drugName: string;
    note: string;
    questions: any[];
    answers: any[];
    notes: Note[];
    lastActivity: string;
    programName: string;
}

export class Consultation {
    constructor(obj?: Consultation) {
        if (obj) {
            Object.assign(this, obj);

            if (obj.notes) {
                this.notes = obj.notes.map(n => new Note(n));
                if (!this.note || this.note.length === 0) {
                    const sortedNotes = this.notes?.filter(n => n.body?.trim().length > 0)
                                            .toSorted((a, b) => b.created.valueOf() - a.created.valueOf());
                    if (sortedNotes.length > 0) this.note = sortedNotes[0].body ?? "";
                }

            }

            if (obj.created) this.created = new Date(obj.created);
            if (obj.closed) this.closed = new Date(obj.closed);
        }
    }
}

export enum ConsultationType {
    General,
    DiseaseState,
    Drug,
    Adherence,
    Injection
}

export enum ConsultationCategory {
    RN,
    RPH
}
